import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await fetch("http://localhost:5000/api/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password })
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.message);
        return;
      }

      localStorage.setItem("cm_admin_token", data.token);
      navigate("/Admin/dashboard");
    } catch (error) {
      alert("Server not reachable");
    }
  };

  return (
    <>
      <Header />

<div className="admin-login-mobile">
    <h2>Sorry Boss</h2>
  Admin Dashboard is accessible only on desktop devices.
</div>
      <div className="admin-login">
        <div className="admin-login-box">
          <h2>Admin Login</h2>

          <input
            type="text"
            placeholder="Admin Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          <input
            type="password"
            placeholder="Admin Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button onClick={handleLogin}>Login</button>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AdminLogin;
